module.exports = __webpack_public_path__ + "static/media/calendar-icon-black.309f304b.svg";